exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".inputText---37djw, .disabled---mxQl9 {\n  height: 38px;\n  width: 375px;\n  padding: 12px 22px;\n  border: 1px solid #e7e9ea;\n  border-radius: 4px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-weight: 500;\n  line-height: 27px;\n  outline: none; }\n\n.disabled---mxQl9 {\n  opacity: 0.4;\n  cursor: not-allowed; }\n", ""]);

// exports
exports.locals = {
	"inputText": "inputText---37djw",
	"disabled": "disabled---mxQl9"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/class-detail/text-input.scss
// module id = 1143
// module chunks = 3